import { CashTransactionFilter, ICashTransactionListState } from './state';
import { createReducer, on, Action } from '@ngrx/store';
import {
  onNgrxForms,
  onNgrxFormsAction,
  SetValueAction,
  createFormGroupState,
  setValue,
} from 'ngrx-forms';
import {
  CashTransactionsResponseAction,
  CashTransactionIncrementPageAction,
  CashTransactionsTypesResponseAction,
  ResetFormAction,
  CashTransactionsSetFromToDateAction,
  CashTransactionsDescriptionResponseAction,
  ResetFilterAction,
} from './actions';
import { Helper } from '@ifaa-components/ui-components';

export const cashtransactionsListFilter = 'cashtransactionsListFilter';
var helper = new Helper();

export const cashTransactionListState: ICashTransactionListState = {
  list: [],
  transactionTypes: [],
  transactionDescription: [],
  filter: createFormGroupState(
    cashtransactionsListFilter,
    new CashTransactionFilter()
  ),
};

const reducer = createReducer(
  cashTransactionListState,

  onNgrxForms(),

  onNgrxFormsAction(SetValueAction, (state, action) => {
    if (
      action.controlId == 'cashtransactionsListFilter.from' ||
      action.controlId == 'cashtransactionsListFilter.to' ||
      action.controlId == 'cashtransactionsListFilter.transactionType' ||
      action.controlId == 'cashtransactionsListFilter.transactionDescription'
    ) {
      const newFilter = {
        ...state.filter.value,
        currentPage: 0,
      };

      return {
        ...state,
        filter: setValue(newFilter)(state.filter),
      };
    }

    return state;
  }),

  on(CashTransactionsSetFromToDateAction, (state, { from, to }) => {
    const clone = helper.clone(state.filter.value);

    clone.from = from;
    clone.to = to;
    clone.currentPage = 0;

    return {
      ...state,
      filter: setValue(clone)(state.filter),
    };
  }),

  on(CashTransactionsResponseAction, (state, { payload }) => {
    const clone = helper.clone(state.filter.value);

    return {
      ...state,
      list: payload,
      filter: setValue(clone)(state.filter),
    };
  }),

  on(ResetFormAction, (state) => {
    return {
      ...state,
      list: [],
      transactionTypes: [],
      transactionDescription: [],
      filter: createFormGroupState(
        cashtransactionsListFilter,
        new CashTransactionFilter()
      ),
    };
  }),

  on(CashTransactionsTypesResponseAction, (state, { payload }) => {
    return {
      ...state,
      transactionTypes: payload,
    };
  }),

  on(CashTransactionsDescriptionResponseAction, (state, { payload }) => {
    return {
      ...state,
      transactionDescription: payload,
    };
  }),

  on(CashTransactionIncrementPageAction, (state) => {
    if (state.filter.value.currentPage === -1) return state;

    const clone = helper.clone(state.filter.value);

    clone.currentPage = state.filter.value.currentPage + 1;

    return {
      ...state,
      filter: setValue(clone)(state.filter),
    };
  }),

  on(ResetFilterAction, (state, {}) => {
    return {
      ...state,
      filter: createFormGroupState(
        cashtransactionsListFilter,
        new CashTransactionFilter()
      ),
      isLoading: true,
    };
  })
);

export function cashTransactionListReducer(
  state: any | undefined,
  action: Action
) {
  return reducer(state, action);
}